export default __webpack_public_path__ + "static/media/watsapp-icon.1dd8ca27.png";